export default __webpack_public_path__ + "static/media/banner-2.bda2365c.jpg";